<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('All codes') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <textarea class="form-control" type="text" id="valuecardCodes" rows="10" v-model="codes"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="copyToClipboard(codes)"><i class="fa fa-clipboard fa-fw"></i> {{ _('Copy to clipboard') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'

export default {
  mixins: [errors],
  props: ['allCodes'],
  computed: {
    codes () {
      if (!this.allCodes || !this.allCodes.length) {
        return ''
      }
      // this.allCodes is an array: Add "-" every four characters and output each one into a separate line
      return this.allCodes.map(code => code.match(/.{1,4}/g).join('-')).join('\n')
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    async copyToClipboard(data) {
      try {
        let status = await this.$copyText(data)
        this.showNotification(this._('Code copied to clipboard!'))
      } catch(e) {
        this.showError(e)
      }
    },
  }
}
</script>